<template>
  <div>
    <div class="text-truncate mt-1" style="max-width: 200px; display: inline-block;">{{ writtenCount > 0 ? value['en'] : 'No translation' }}</div>
    <div class="caption grey--text text--darker-1">{{ writtenCount }} languages written</div>
</div>
</template>

<script>

export default {
  name: 'TranslatableCell',
  props: {
    value: {
      type: [Object, null]
    }
  },
  computed: {
    langs () {
      return this.$store.getters.langs
    },
    writtenCount () {
      if (!this.value) {
        return 0
      }
      return Object.keys(this.value).filter(key => this.value[key] !== '').length
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tables/TranslatableCell.vue